import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { convertLenderInformationDataToLenderForm } from 'types/lenders/convertLenderInformationToLenderForm';
import { ILenderInformationData } from 'types/lenders/ILenderInformation';
import { Card } from 'ui-toolkit';
import { LenderCompanyForm } from './LenderCompanyCreateForm';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { useUpdateLenderMutation } from '../../API/lenders/LenderCompanyApi';
import { checkForMutationSuccess } from '../../API/checkForMutationSuccess';
import { ILenderRequest } from '../../types/lenders/ILenderRequest';

export interface IEditLenderContainerProps {
  lender: ILenderInformationData;
}

export const EditLenderContainer: React.FC<IEditLenderContainerProps> = ({ lender }) => {
  const history = useHistory();
  const [updateLenderCompany] = useUpdateLenderMutation();
  const onSubmit = async (data: ILenderRequest) => {
    const result = await updateLenderCompany({ id: lender.lender.id, body: data });
    if (checkForMutationSuccess(result, 'Updating Lender Company', 'Error Updating Lender Company')) {
      history.push(ClientUrlFactory().urlFor.lenderCompany(lender.lender.id));
    }
  };

  const initialValues = useMemo(() => {
    return convertLenderInformationDataToLenderForm(lender);
  }, [lender]);
  return (
    <Card title={`Edit Lender Company: ${lender.lender.name}`}>
      <LenderCompanyForm onSubmit={onSubmit} initialValues={initialValues} onSubmitLabel={'Update'} />
    </Card>
  );
};
